export const hasDecimals = num =>
    num % 1 !== 0;
